import {useContrato} from "@components/contratos/hooks/useContrato.tsx";
import React from "react";
import {NavButton, NavButtonProps} from "@shared/custom/NavButton.tsx";
import {IContratoParcela} from "@models/contratos/parcelamento.ts";

interface ContratoParcelaNavProps extends Omit<NavButtonProps<IContratoParcela>, 'value'> {
    value: IContratoParcela | number;
}

export function ContratoParcelaNav(props: ContratoParcelaNavProps) {
    const {useParcelaValue} = useContrato()
    const [value] = useParcelaValue(props.value)

    const handleCtx = (_e: React.MouseEvent<HTMLElement>) => {
        // if (value == null) return
        return null
    }


    return (value != null && <NavButton
        pathname={'/contratos/detalhes'}
        onContextMenu={handleCtx}
        hint={"Ir para a pagina de detalhes a parcela " + value.id}
        onClick={props.onClick}
        displayMode={'numero'}
        permissoesNecessarias={['VisualizarContratos']}
        searchData={{contratoId: value.contratoId, contratoParcelaId: value.id}}
        {...props}
        value={typeof props.value != "number" ? props.value : value}
    />)
}